import { Outlet } from "react-router-dom";
import { useAdminLoading } from "../../../context/AdminLoadingContext";
import AdminLayoutSideBar from "./AdminLayoutSideBar";
import Header from "./AdminLayoutHeader";
import AdminLayoutGlobalLoading from "./AdminLayoutGlobalLoading";

export default function AdminLayout() {
  const { isLoading } = useAdminLoading();

  return (
    <div className="flex flex-col relative">
      {isLoading && <AdminLayoutGlobalLoading />}
      <div className="w-full h-14 fixed flex items-center px-16 2xl:px-32 border-b card-shadow bg-white z-50">
        <Header />
      </div>
      <div className=" flex flex-row gap-6 mt-16 mb-10 mx-20" dir="rtl">
        <div className=" w-[250px] h-auto bg-white border border-gray-200 py-4 px-3 rounded-2xl flex-shrink-0">
          <AdminLayoutSideBar />
        </div>
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
